import { Reducer } from 'redux';
import { OrdemCargaState, OrdemCargaTypes } from './types';

const INITIAL_STATE: OrdemCargaState = {
  data: undefined,
  error: false,
  loading: false,
};

const reducer: Reducer<OrdemCargaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OrdemCargaTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OrdemCargaTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case OrdemCargaTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: undefined,
      };
    case OrdemCargaTypes.CLEAN_ORDEMCARGA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
